var map = {
	"./Andre_Torlen_Lonvik.jpg": 63,
	"./IAMK_posters.png": 64,
	"./KoLab.png": 65,
	"./NTNUI-Redesign.jpg": 66,
	"./NewCV_Design.jpg": 67,
	"./Web 1920 – 1.png": 68,
	"./internship.png": 69,
	"./redesign-logo.png": 70,
	"./vrIconDesign.png": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;